import { render } from "./ParentInfo.vue?vue&type=template&id=42b73679&scoped=true"
import script from "./ParentInfo.vue?vue&type=script&lang=js"
export * from "./ParentInfo.vue?vue&type=script&lang=js"

import "./ParentInfo.vue?vue&type=style&index=0&id=42b73679&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42b73679"]])

export default __exports__